import styled from 'styled-components';

const ScopedCssBaseLine = styled.div`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  font-size: 14px;
  line-height: 1.5;

  // [customer-site-conflict-issue][css]
  & svg {
    display: inline-block;
  }

  & h1,
  h2,
  h3,
  h4,
  h5,
  p {
    margin: 0;
  }

  a {
    color: ${({ theme }) => theme.configs.secondaryBox.fontColor};
    text-decoration: underline;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
`;

export default ScopedCssBaseLine;
